import { jsx as e, jsxs as o } from "react/jsx-runtime";
import * as i from "react";
import { cn as m } from "../../utils.js";
import { Typography as c } from "../Typography/index.js";
const p = i.forwardRef(
  ({ className: r, label: a, htmlFor: t, required: l }, s) => /* @__PURE__ */ e(
    "label",
    {
      ref: s,
      htmlFor: t,
      className: m("mb-0.75 inline-block first-letter:uppercase", r),
      children: /* @__PURE__ */ o(c, { className: "font-semibold", children: [
        a,
        l && /* @__PURE__ */ e("span", { className: "text-critical", children: "*" })
      ] })
    }
  )
);
p.displayName = "InputLabel";
export {
  p as InputLabel
};
